import BG_SanFrancisco from './images/backgrounds/sanfrancisco_640.jpg';
import BG_London from './images/backgrounds/london_640.jpg';
import BG_Singapore from './images/backgrounds/singapore.jpg';
import BG_Sydney from './images/backgrounds/sydney_640.jpg'
import BG_Lisbon from './images/backgrounds/lisbon.jpg';
import BG_Berlin from './images/backgrounds/berlin_640.jpg';
import BG_Newyork from './images/backgrounds/newyork_640.jpg';

import BG_Melbourne from './images/backgrounds/melbourne_1400.jpg';
import BG_Bengaluru from './images/backgrounds/bengaluru_1400.jpg';
import BG_Auckland from './images/backgrounds/auckland_1400.jpg';
import BG_Boston from './images/backgrounds/boston_1400.jpg';
import BG_Brisbane from './images/backgrounds/brisbane_1400.jpg';
import BG_Paloalto from './images/backgrounds/paloalto_1400.jpg';
import BG_Chicago from './images/backgrounds/chicago_1400.jpg';


const ABOUT_MAP_OPTIONS = {
    zoom: 3,
    center: [19.93658, 50.06143]
}




const INDEX_SLATES = [
    {
        image: BG_SanFrancisco,
        line1: "San Francisco",
        line2: "California, USA",
        color: "rgba(255, 168, 41, 0.3)",

        urlParams: {
            center: { lat: 37.7749, lng: -122.4194 },
            zoom: 10,
        },

        searchParams: {
            location: "San Francisco"
        },

        countParams: {
            distance: "10km",
        },
    },

    {
        image: BG_London,
        line1: "London",
        line2: "UK",
        color: "rgba(177, 93, 73, 0.6)",

        urlParams: {
            center: { lat: 51.5074, lng: -0.1278 },
            zoom: 11,
        },

        searchParams: {
            location: "London"
        },

        countParams: {
            distance: "10km",
        },

    },

    {
        image: BG_Singapore,
        line1: "Singapore",
        line2: "Republic of Singapore",
        color: "rgba(31, 54, 95, 0.6)",

        urlParams: {
            center: { lat: 1.3521, lng: 103.8198 },
            zoom: 11
        },

        searchParams: {
            location: "Singapore"
        },

        countParams: {
            distance: "10km",
        }

    },

    {
        image: BG_Sydney,
        line1: "Sydney",
        line2: "Australia",
        color: "rgba(42, 87, 95, 0.6)",

        urlParams: {
            center: {lat: -33.8688, lng: 151.2093},
            zoom: 11,
        },

        searchParams: {
            location: "Sydney"
        },

        countParams: {
            distance: "10km",
        }
    },

    {
        image: BG_Lisbon,
        line1: "Lisbon",
        line2: "Portugal",
        color: "rgba(187, 154, 104, 0.6)",

        urlParams: {
            center: {lat: 38.7223, lng: -9.1393},
            zoom: 11,
        },

        searchParams: {
            location: "Lisbone"
        },

        countParams: {
            distance: "10km",
        }

    },

    {
        image: BG_Berlin,
        line1: "Berlin",
        line2: "Germany",
        color: "rgba(162, 142, 167, 0.6)",

        urlParams: {
            center: { lat: 52.5200, lng: 13.4050 },
            zoom: 10,
        },

        searchParams: {
            location: "Berlin"
        },        

        countParams: {
            distance: "10km",
        }

    },

    {
        image: BG_Newyork,
        line1: "New York",
        line2: "New York, USA",
        color: "rgba(187, 154, 104, 0.6)",

        urlParams: {
            center: { lat: 40.7128, lng: -74.0059 },
            zoom: 10,
        },

        searchParams: {
            location: "New York"
        },

        countParams: {
            distance: "10km",
        }

    },

    // {
    //     image: '/images/backgrounds/auckland_640.jpg',
    //     line1: "Auckland",
    //     line2: "New Zealand",
    //     color: "rgba(91, 95, 31, 0.6)",

    //     urlParams: {
    //         center: {lat: -36.8485, lng: 174.7633},
    //         zoom: 10,
    //     },

    //     searchParams: {
    //         location: "Auckland"
    //     },

    //     countParams: {
    //         distance: "10km",
    //     }

    // },

    // {
    //     image: '/images/backgrounds/bengaluru_640.jpg',
    //     line1: "Bangalore",
    //     line2: "India",
    //     color: "rgba(91, 95, 31, 0.6)",
    //     params: {
    //         lat: 12.9716,
    //         lng: 77.5946,
    //         zoom: 11,
    //     },
    //     search: {
    //         distance: "10km",
    //         location: "Bangalore"
    //     }
    // },

    // {
    //     image: '/images/backgrounds/boston_640.jpg',
    //     line1: "Boston",
    //     line2: "Massachusetts, USA",
    //     color: "rgba(255, 168, 41, 0.3)",
    //     params: {
    //         lat: 42.36011,
    //         lng: -71.0589,
    //         zoom: 11,
    //     },
    //     search: {
    //         distance: "10km",
    //         location: "Boston"
    //     }
    // },

    // {
    //     image: '/images/backgrounds/brisbane_640.jpg',
    //     line1: "Brisbane",
    //     line2: "Australia",
    //     color: "rgba(162, 142, 167, 0.6)",
    //     params: {
    //         lat: -27.4698,
    //         lng: 153.0251,
    //         zoom: 11,
    //     },
    //     search: {
    //         distance: "10km",
    //         location: "Brisbane"
    //     }
    // },

    // {
    //     image: '/images/backgrounds/paloalto_640.jpg',
    //     line1: "Palo Alto",
    //     line2: "California, USA",
    //     color: "rgba(91, 95, 31, 0.6)",

    //     params: {
    //         lat: 37.4419,
    //         lng: -122.1430,
    //         zoom: 11,
    //     },
    //     search: {
    //         distance: "10km",
    //         location: "Palo Alto"
    //     }
    // }

];

const INDEX_JOB_TITLES = [
    "a Python Developer",
    "a UX Designer",
    "a Project Manager",
    "a Growth Hacker",
    "a React Developer",
    "an Angular Programmer",
]

const INDEX_ANIMATIONS = [
    {
        background: BG_SanFrancisco,
        text: "San Francisco"
    },
    {
        background: BG_Berlin,
        text: "Berlin"
    },
    {
        background: BG_Chicago,
        text: "Chicago"
    },
    {
        background: BG_London,
        text: "London"
    },
    {
        background: BG_Melbourne,
        text: "Melbourne"
    },
    {
        background: BG_Newyork,
        text: "New York"
    },
    {
        background: BG_Sydney,
        text: "Sydney"
    },
    {
        background: BG_Bengaluru,
        text: "Bangalore"
    },
    {
        background: BG_Auckland,
        text: "Auckland"
    },
    {
        background: BG_Boston,
        text: "Boston"
    },
    {
        background: BG_Brisbane,
        text: "Brisbane"
    },
    {
        background: BG_Paloalto,
        text: "Palo Alto"
    }
];


export {
    ABOUT_MAP_OPTIONS,
    INDEX_SLATES,
    INDEX_ANIMATIONS,
    INDEX_JOB_TITLES,
};
